export default "__VITE_ASSET__g7xzwJbI__"